import { AdminPermission } from '../../types/permissions/admin-permission-enum';
import { User } from '../../types/user';

export function isLimitedAdminPermission(
  user: User | undefined,
): undefined | boolean {
  return user?.permissions?.includes(AdminPermission.ROLE_LIMITED_APTADMIN);
}
